// Library Methods
import { useRef } from "react";

// Components
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

// Styles
import {
  CustomTextFieldProps,
  getSurfaceTokens,
} from "src/styles/mui/muiStylesHelper";

const DEFAULT_COLOR = "#000000";

type ColorPickerFieldType = {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
};

const ColorPickerField = ({
  value,
  onChange,
  disabled = false,
}: ColorPickerFieldType) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const theme = useTheme();
  const { onSurface } = getSurfaceTokens(theme);

  const handleSwatchClick = () => {
    if (!disabled) inputRef.current?.click();
  };

  return (
    <Box
      onClick={handleSwatchClick}
      sx={{
        ...CustomTextFieldProps(theme),
        display: "flex",
        alignItems: "center",
        gap: "8px",
        border: "1px solid #8B94A1",
        padding: "0px 16px",
        cursor: disabled ? "default" : "pointer",
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <Box
        sx={{
          width: "20px",
          height: "20px",
          flexShrink: 0,
          borderRadius: "4px",
          border: "1px solid #8B94A1",
          backgroundColor: value || DEFAULT_COLOR,
        }}
      />
      <Box
        component="span"
        sx={{
          fontSize: "14px",
          color: onSurface,
        }}
      >
        {value || DEFAULT_COLOR}
      </Box>
      <input
        ref={inputRef}
        type="color"
        aria-label="Select custom tint color"
        value={value || DEFAULT_COLOR}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        style={{
          position: "absolute",
          width: 0,
          height: 0,
          padding: 0,
          border: "none",
          opacity: 0,
          pointerEvents: "none",
        }}
      />
    </Box>
  );
};

export default ColorPickerField;
